import ReactController from '~/controllers/react_controller'
import AzureDiskMetricsCharts from '~/dashboard/azure_disk_metrics_charts'

export default class AzureDiskMetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
  }

  createComponent() {
    return <AzureDiskMetricsCharts organizationId={this.organizationIdValue} resourceId={this.resourceIdValue} />
  }
}
